<template>
  <span
    :class="[
      'material-symbols-outlined',
      'select-none',
      inheritColor ? '' : 'text-blue-grey-90',
    ]"
    >{{ glyph }}</span
  >
</template>

<script setup lang="ts">
import { iconCodePoints, type EnabledIconName } from './icon'

interface Props {
  name: EnabledIconName
  fill?: boolean
  size?: number
  inheritColor?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  fill: false,
  size: 24,
  inheritColor: false,
})

const glyph = computed(() =>
  String.fromCodePoint(parseInt(iconCodePoints[props.name], 16)),
)

const fill = computed(() => (props.fill ? 1 : 0))
const px = computed(() => `${props.size}px`)
</script>

<style scoped>
.material-symbols-outlined {
  font-family: 'Material Symbols Outlined';
  font-weight: normal;
  font-style: normal;
  font-size: v-bind(px);
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  user-select: none;
  width: v-bind(px);
  height: v-bind(px);
  font-variation-settings:
    'wght' 400,
    'opsz' v-bind(size),
    'FILL' v-bind(fill),
    'GRAD' 0;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}
</style>
